import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import StudentTestimonialForm from "../Layout/StudentTestimonialForm";
import { StudentTestimonialFormValues } from "src/models/StudentTestimonial.model";
import {
  useEditTestimonialMutation,
  useGetTestimonialByIdQuery,
} from "src/services/StudentTestimonialServices";
type Props = {
  onClose: () => void;
  testimonialId: string;
};

const EditStudentTestimonialFormWrapper = ({
  onClose,
  testimonialId,
}: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);
  const [Testimonial, setTestimonialData] = useState<any>({});

  const [editTestimonial] = useEditTestimonialMutation();
  const { data, isLoading, isFetching } = useGetTestimonialByIdQuery({
    id: testimonialId,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setTestimonialData(data?.data);
    }
  }, [data, isLoading, isFetching]);

  // Form Initial Values
  const initialValues: StudentTestimonialFormValues = {
    image: Testimonial?.image || "",
    video: Testimonial?.video || "",
    name: Testimonial?.name || "",
    text: Testimonial?.text || "",
    currentCompany: Testimonial.currentCompany || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string().required("Please enter student name"),
    text: string().required("Please enter testimonial"),
    currentCompany: string().required("Please enter current company"),
  });

  // Handle Submit
  const handleSubmit = (
    values: StudentTestimonialFormValues,
    { setSubmitting, resetForm }: FormikHelpers<StudentTestimonialFormValues>
  ) => {
    const formatedValue = {
      image: values.image,
      video: values.video,
      name: values.name,
      text: values.text,
      currentCompany: values.currentCompany,
    };
    editTestimonial({
      body: formatedValue,
      id: testimonialId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xl" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form className="h-full overflow-hidden contents">
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <StudentTestimonialForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Edit"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditStudentTestimonialFormWrapper;
